import { createFileRoute } from '@tanstack/react-router';

import { buildSeoHead, ROUTE_META } from '@src/corelib/seo';
import { DefaultLayout } from '@src/layout';
import TermsOfService from '@src/pages/TermsOfService';

export const Route = createFileRoute('/terms-of-service')({
  head: () => buildSeoHead({ path: '/terms-of-service', ...ROUTE_META['/terms-of-service'] }),
  component: TermsOfServicePageWithLayout,
});

function TermsOfServicePageWithLayout() {
  return (
    <DefaultLayout>
      <TermsOfService />
    </DefaultLayout>
  );
}
